import React from 'react';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip';

export interface TruncatedTextProps {
	text: string;
	className?: string;
}

export function TruncatedText({ text, className = '' }: TruncatedTextProps) {
	if (!text) {
		return null;
	}

	return (
		<TailwindTooltip
			reference={<span className={`block min-w-0 truncate ${className}`}>{text}</span>}
			displayClass='block min-w-0 max-w-full'
		>
			{text}
		</TailwindTooltip>
	);
}
